module.exports = __webpack_public_path__ + "img/logo1.76849242.png";